<template>
    <div class="container">
        <div class="mt-2">
            <a href="/">EXIT</a>
        </div>
        <div class="py-5 text-center">
            <h2 class="mb-3">Admin Summar</h2>
            <p class="lead">Panel administración de uso exclusivo para soporte Summar</p>
        </div>
        <div class="row">
            <div class="col-3">
                <div class="card">
                    <div class="body">
                        <h6 class="card-subtitle mb-2 text-muted">Test email</h6>
                        <div class="form-group">
                            <input type="text" class="form-control" v-model="email">
                        </div>
                        <a href="#" class="btn btn-info" v-on:click.prevent="sendEmail">Enviar</a>

                        <div v-if="portalConfig.isLaborSmtpConfig == '1'">
                            <small> Para la opción 'Usar autenticación Labor' i autenticacion 'Básica' en Labor </small>
                            <a href="#" class="btn btn-primary btn-block" v-on:click.prevent="testWSSmtpConfig">Test WS SMTP Config</a>
                        </div>
                        <div v-if="portalConfig.isOauth2Smtp == '1'">
                            <small> Para la autenticación 'OAuth 2.0'  </small>
                            <a href="#" class="btn btn-primary btn-block" v-on:click.prevent="testWSOAuth">Test WS SMTP Oauth token</a>
                        </div>
                        <div>
                            <small> Test WS Services</small>
                            <a href="#" class="btn btn-primary btn-block" v-on:click.prevent="testWS">Test WS Services</a>
                        </div>
                        <div>
                            <small> Test WS Fusion Documentos </small>
                            <a href="#" class="btn btn-primary btn-block" v-on:click.prevent="testWSFusionDocs">Test WS Fusion Documentos</a>
                        </div>
                    </div>
                </div>  
            </div>
            <div class="col-3">
                <div class="card">
                    <div class="body">
                        <h6 class="mb-2 text-muted">Test WS Anexo</h6>
                        <a href="#" class="btn btn-primary" v-on:click.prevent="testWSAnexo">Test WS Anexo</a>
                    </div>
                </div>
                <div class="card">
                    <div class="body">
                        <h6 class="mb-2 text-muted">AppSettings</h6>
                        <a href="#" class="btn btn-primary" v-on:click.prevent="encryptConnection">Encriptar ConnectionString</a>
                    </div>
                </div>
            </div>
            <div class="col-3">
                <div class="card">
                    <div class="body">
                        <h6 class="mb-2 text-muted">Log de errores</h6>
                        <a href="#" class="btn btn-info btn-block" v-on:click.prevent="loadLog">Mostrar log</a>
                        <a href="#" class="btn btn-block" v-on:click.prevent="testLog">Test escribir</a>
                        <a href="#" class="btn btn-block" v-on:click.prevent="descargarLog">Descargar fichero</a>
                        <a href="#" class="btn btn-secondary btn-block" v-on:click.prevent="emptyLog">Vaciar Log</a>
                        <br/>
                        <small>Modificar log en la BBDD:</small>
                        <input type="text" class="form-control" placeholder="Ruta log en la BBDD" v-model="portalConfig.pathLog">
                        <div class="row">
                            <div class="col-4">
                                Nivel: 
                            </div>
                            <div class="col-8">
                                <select id="select-logLevel" v-model="portalConfig.logLevel" class="form-control" >
                                    <option v-for="level in logLevels" v-bind:key="level" v-bind:value="level" >{{ level }}</option>
                                </select>
                            </div>
                        </div>
                        <a href="#" class="btn btn-warning btn-block" v-on:click.prevent="updLog">Modificar</a>
                    </div>
                </div>
            </div>
             <div class="col-3">
                <div class="card">
                    <div class="body">
                        <h6 class="mb-2 text-muted">Summar Update</h6>
                        <p :class="{ 'bg-danger': updatorInfo.updatorInstalled!=1, 'bg-success': updatorInfo.updatorInstalled==1 }" class="text-white p-2">{{updatorInfo.installError}}</p>
                        <p><b>Versión instalada:</b> {{updatorInfo.version}}</p>
                        <p><b>Versión disponible:</b> {{updatorInfo.availableVersion}}</p>
                        <div v-if="updatorInfo.updatorInstalled == 1 || updatorInfo.updatorInstalled == 2">
                            <a href="#" class="btn btn-primary" v-on:click.prevent="updatePortal('ADMIN')">Actualizar portal</a><br />
                            <a href="#" class="btn btn-secondary" v-on:click.prevent="updatePortal('BACKUP')">Restaurar backup</a><br />
                        </div>
                        <div v-if="updatorInfo.updatorInstalled != -1">
                            <a href="#" class="btn btn-secondary" v-on:click.prevent="loadLogUpdator">Mostrar Log</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row" v-show="message">
            <div class="col">
                <div :class="'alert d-inline-block ' + alertType"><span v-html="message"></span></div>
            </div>
        </div>

        <!--tabla log -->
        <table class="w-100 table table-striped table-hover table-mobile" v-if="this.datosLog != ''">
            <thead>
                <tr>
                    <th>ID</th>
                    <th>Fecha</th>
                    <th>Tipo</th>
                    <th>Navegador</th>
                    <th>Mensaje</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(datosLog, index) in this.datosLog" v-bind:key="index">
                    <td>{{ datosLog.ID }}</td>
                    <td>{{ datosLog.Fecha }}</td>
                    <td>{{ datosLog.Tipo }}</td>
                    <td>{{ datosLog.Navegador }}</td>
                    <td>{{ datosLog.Mensaje }}</td>
                </tr>
            </tbody>
        </table>

        <!--tabla log updator -->
        <table class="w-100 table table-striped table-hover table-mobile" v-if="this.logUpdator != ''">
            <thead>
                <tr>
                    <th>Fecha</th>
                    <th>Mensaje</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(datosLog, index) in this.logUpdator" v-bind:key="index">
                    <td>{{ datosLog.Fecha }}</td>
                    <td>{{ datosLog.Mensaje }}</td>
                </tr>
            </tbody>
        </table>

    </div>
</template>

<script>
    import { adminService } from '../api/admin';
    import { configService } from '../api/config';
    import { cookie } from '@/_utils/cookie'
    import Vue from 'vue'
    export default {
        name: 'Admin',
        data() {
                return {
                    email: '',
                    message: '',
                    alertType: 'alert-success',
                    datosLog: '',
                    logUpdator: '',
                    logLevels: ['NOTHING', 'ERROR', 'INFO', 'DEBUG'],
                    updatorInfo: [],
                    portalConfig: [],
                }
        },
        methods: {
            async sendEmail() {
                this.message = '';
                if(await adminService.sendEmail(this.email)) this.email = '';
            },

            async encryptConnection() {
                let respuesta = await adminService.encryptConnection();
                if (respuesta.valid){
                    this.message = respuesta.message;
                    this.alertType = 'alert-success';
                }
                else{
                    this.message = respuesta.message;
                    this.alertType = 'alert-danger';
                }
            },

            async updLog() {
                let respuesta = await adminService.updLog(this.portalConfig.pathLog, this.portalConfig.logLevel);
                if (respuesta.valid){ 
                    this.message = 'Ruta log actualizada';
                    this.alertType = 'alert-success';
                }
                else{
                    this.message = respuesta.message;
                    this.alertType = 'alert-danger';
                }
            },
            async loadLog() {
                this.logUpdator = '';
                let respuesta = await adminService.loadLog();
                if (respuesta.valid){
                     this.datosLog = respuesta.message;
                     this.alertType = 'alert-success';
                }
            },
            async testLog() {
                let respuesta = await adminService.testLog();
                if (respuesta.valid){
                    this.message = 'Test de escritura realizado correctamente';
                    this.alertType = 'alert-success';
                }
                else{
                    this.message = respuesta.message;
                    this.alertType = 'alert-danger';
                }
            },
            async descargarLog() {
                let respuesta = await adminService.descargarLog();
                const link = document.createElement('a')
                link.href = window.URL.createObjectURL(new Blob([respuesta.data]))
                link.setAttribute('download', respuesta.name)
                document.body.appendChild(link)
                link.click()
            },
            async emptyLog() {
                let respuesta = await adminService.emptyLog();
                if (respuesta.valid){
                     this.message = 'Log vaciado';
                     this.alertType = 'alert-success';
                }
                else{
                    this.message = respuesta.message;
                    this.alertType = 'alert-danger';
                }
            },
                
            async updatePortal(action)
            {
                let response = await adminService.updatePortal(action);

                if (response.status == 200) {
                    // Mostramos página del log
                    window.location.href = Vue.prototype.$Params.urlBase + "update.html"
                }
            },
            async loadLogUpdator() {
                this.datosLog = '';
                let respuesta = await adminService.loadLogUpdator();
                if (respuesta.valid) this.logUpdator = respuesta.message;
            },

            async testWSSmtpConfig() {
                this.message = '';
                let respuesta = await adminService.testWSSmtpConfig();
                if (respuesta.status==200){
                    this.message = 'El WS responde';
                    this.alertType = 'alert-success';
                }
                else{
                    this.message = respuesta.message;
                    this.alertType = 'alert-danger';
                }
            },
            async testWSOAuth() {
                this.message = '';
                let respuesta = await adminService.testWSOAuth();
                if (respuesta.status==200){
                    this.message = 'El WS responde';
                    this.alertType = 'alert-success';
                }
                else{
                    this.message = respuesta.message;
                    this.alertType = 'alert-danger';
                }
            },
            async testWS() {
                this.message = '';
                let respuesta = await adminService.testWS();
                if (respuesta.status==200){
                    this.message = 'WebService Activo';
                    this.alertType = 'alert-success';
                }
                else{
                    this.message = respuesta.message;
                    this.alertType = 'alert-danger';
                }
            },
            async testWSFusionDocs() {
                this.message = '';
                let respuesta = await adminService.testWSFusionDocs();
                if (respuesta.status==200){
                    this.message = 'El WS responde';
                    this.alertType = 'alert-success';
                }
                else{
                    this.message = respuesta.message;
                    this.alertType = 'alert-danger';
                }
            },
            async testWSAnexo() {
                this.message = '';
                let respuesta = await adminService.testWSAnexo();
                if (respuesta.status==200){
                    this.message = 'El test de la descarga WS es correcto';
                    this.alertType = 'alert-success';
                }
                else{
                    this.message = respuesta.message;
                    this.alertType = 'alert-danger';
                }
            },
        },
        async created() {
            
            document.body.classList.add('admin-panel');

            //se ha hecho login desde summarServices
            if(this.$route.query.sys != undefined)
                cookie.setToken(this.$route.query.sys);

            let respuesta = await configService.adminPageParams();
            this.portalConfig = respuesta;

            this.updatorInfo = await adminService.updateInfo();
        }
    }

</script>